export default __webpack_public_path__ + "static/media/instagram.77a80e54.svg";